import { computed } from 'vue'
import { useExperiment } from '/@/core/experiment'

export function useBuyNowCtaTextExperiment() {
  const { variant, loading } = useExperiment('buy-now-cta-text-v2')
  const cta = computed(() =>
    variant.value?.payload && 'text' in variant.value.payload
      ? variant.value.payload['text']
      : 'Buy now',
  )
  const loaded = computed(() => Boolean(variant.value))

  return { cta, loading, loaded }
}
